<template>
  <div class="p-6 bg-white rounded-lg">
    <header class="mb-6">
      <h3 class="text-2xl font-bold">
        Accessible Subject Areas
      </h3>
    </header>
    <section>
      <d-table 
        class="bg-white shadow mt-4 mb-5" 
        :data="subjectAreas" 
        :columns="tableColumns"
        :loading="loading" 
        backend-search 
        backend-sorting 
        :default-sort="[pagination.sortField, pagination.sortOrder]" 
        striped 
        default-sort-direction="desc" 
        @sort="onSort">
        <template #default="{ row }">
          <td class="lg:w-3/12 md:w-1/12">
            <p>{{ row.name }}</p>
          </td>
        </template>
      </d-table>
    </section>
    <footer class="flex justify-end mt-6">
      <d-btn flat @click="$emit('close')">
        Close
      </d-btn>
    </footer>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      user: {
        type: Object,
        default: () => { },
      },
    },

    emits: ['close'],

    data: () => ({
      subjectAreas: [],
      loading: false,
      filter: '',
      total: 0,
      pagination: {
        page: 1,
        pageSize: 20,
        sortField: 'order',
        sortOrder: 'asc',
      },
      tableColumns: [
        { field: 'name', label: 'Name', sortable: true }
      ]
    }),

    mounted() {
      this.getSubjectAreasPaged();
    },

    methods: {
      async getSubjectAreasPaged() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`filter=${this.filter}`, `sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`].join('&');
        this.loading = true;
        const { data } = await axios.get(`/api/subject-areas/${this.user.id}/paged?${params}`);
        this.subjectAreas = data.resultItems;
        this.total = data.totalRecords;
        this.loading = false;
      },

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },
    },
  };
</script>